'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (AppointmentRequestStatusType) {
    AppointmentRequestStatusType["sentNoResponse"] = "sentNoResponse";
    AppointmentRequestStatusType["readyForBooking"] = "readyForBooking";
    AppointmentRequestStatusType["failed"] = "failed";
    AppointmentRequestStatusType["sent"] = "sent";
    AppointmentRequestStatusType["inProgress"] = "inProgress";
    AppointmentRequestStatusType["queued"] = "queued";
})(exports.AppointmentRequestStatusType || (exports.AppointmentRequestStatusType = {}));
